export default __webpack_public_path__ + "static/media/icon-20-icn-event-acceleration.1945ed51.svg";